module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 function isActive(name){
return obj.order_by_column === name ? 'is-active' : '';
} 
__p+='\n\n<div class="column column-first '+
((__t=( isActive('name') ))==null?'':_.escape(__t))+
'">\n	<figure>\n		<picture>\n			<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n			<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100 }) ))==null?'':_.escape(__t))+
'" alt="">\n		</picture>\n	</figure>\n	<div class="player-info">\n		<div class="player-name">\n			<i class="player-status '+
((__t=( status ))==null?'':_.escape(__t))+
'"></i>\n			<span>'+
((__t=( first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( last_name ))==null?'':_.escape(__t))+
'</span>\n		</div>\n		<div class="player-stats">\n			<span class="player-opponent">\n				<b>'+
((__t=( squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( opponent.short_name ))==null?'':_.escape(__t))+
'\n			</span>\n			<span> | </span>\n			<span class="player-positions">\n				'+
((__t=( position_names.join(', ') ))==null?'':_.escape(__t))+
'\n			</span>\n			<br>\n			<span class="player-cost">\n				'+
((__t=( _.currencyFormat(cost) ))==null?'':_.escape(__t))+
'\n			</span>\n			<span>&nbsp;|&nbsp;</span>\n			<span class="'+
((__t=( cost_season_diff > 0 ? 'positive' : '' || cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.currencyFormat(cost_season_diff, '$', true) ))==null?'':_.escape(__t))+
'\n			</span>\n			<span> </span>\n			(\n			<span class="'+
((__t=( cost_round_diff > 0 ? 'positive' : '' || cost_round_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.currencyFormat(cost_round_diff, '$', true) ))==null?'':_.escape(__t))+
'\n			</span>\n			)\n		</div>\n	</div>\n</div>\n<div class="column '+
((__t=( isActive('cost') ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( _.currencyFormat(cost) ))==null?'':_.escape(__t))+
'\n</div>\n<div class="column '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( stats.avg_points ))==null?'':_.escape(__t))+
'\n</div>\n<div class="column '+
((__t=( isActive('stats.venue_avg_one_round_after_current') ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( _.result(stats, 'venue_avg_one_round_after_current', '-') ))==null?'':_.escape(__t))+
'\n	&nbsp;\n	('+
((__t=( _.result(stats, 'future_games[0].venue.short_name') || '-' ))==null?'':_.escape(__t))+
')\n</div>\n<div class="column '+
((__t=( isActive('stats.venue_avg_two_rounds_after_current') ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( _.result(stats, 'venue_avg_two_rounds_after_current', '-') ))==null?'':_.escape(__t))+
'\n	&nbsp;\n	('+
((__t=( _.result(stats, 'future_games[1].venue.short_name') || '-' ))==null?'':_.escape(__t))+
')\n</div>\n<div class="column '+
((__t=( isActive('stats.venue_avg_three_rounds_after_current') ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( _.result(stats, 'venue_avg_three_rounds_after_current', '-') ))==null?'':_.escape(__t))+
'\n	&nbsp;\n	('+
((__t=( _.result(stats, 'future_games[2].venue.short_name') || '-' ))==null?'':_.escape(__t))+
')\n</div>\n<div class="column '+
((__t=( isActive('stats.venue_avg_3_rounds') ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( stats.venue_avg_3_rounds ))==null?'':_.escape(__t))+
'\n</div>';
}
return __p;
};
